import { FaRegBell } from "react-icons/fa";
import "./Notifications.css";
import { useEffect, useRef, useState } from "react";
import { useNotifications } from "../../contexts/notifications";
import { LuCheckCheck } from "react-icons/lu";
import { LuInbox } from "react-icons/lu";
import { NotificationCard } from "./NotificationCard";
import { useScrollEnd } from "../../hooks/useScrollEnd";
import { useVisible } from "../../hooks/useVisible";
import { throttle } from "../../utils/timer";
import Loader from "../Loader/Loader";
import { AnimatedTabbar, AnimatedTabbarItem } from "../AnimatedTabbar/AnimatedTabbar";

export const Notifications = (props) => {
	const [showDropdown, setShowDropdown] = useState(false);
	const { notifications, readAll, loadNotifications, totalUnread, isLoading, setCategorySearchBy } = useNotifications();
	const dropdownRef = useRef();
	const triggerRef = useRef();
	const { updateElement: updateElementScrollEnd, isOnEnd } = useScrollEnd({ onScrollEnd });
	const { updateElement: updateElementVisible } = useVisible({ onVisible });
	const loadNotificationsDebounce = throttle(loadNotifications, 1200);
	const [tab, setTab] = useState(1)

	const handleClickBell = async () => {
		setShowDropdown(!showDropdown);
	};

	useEffect(() => {
		function handleClickOutside(event) {
			if (
				dropdownRef.current && !dropdownRef.current.contains(event.target) &&
				triggerRef.current && !triggerRef.current.contains(event.target)
			) {
				setShowDropdown(false);
			}
		}
		function handleEscape(event) {
			if (event.key === 'Escape') {
				setShowDropdown(false);
			}
		}
		updateElementScrollEnd(dropdownRef)
		updateElementVisible(dropdownRef)
		document.addEventListener('keyup', handleEscape);
		document.addEventListener('mouseup', handleClickOutside);
		return () => {
			document.removeEventListener('keyup', handleEscape);
			document.removeEventListener('mouseup', handleClickOutside);
		}
	}, [dropdownRef])

	async function onScrollEnd() {
		loadNotificationsDebounce();
	}

	async function onVisible() {
		if (isOnEnd()) {
			loadNotificationsDebounce();
		}
	}

	async function onReadAllClick(event) {
		readAll();
	}

	return (
		<>
			<button
				type="button"
				ref={triggerRef}
				className="notification-bell-container"
				onClick={() => handleClickBell()}
			>
				<FaRegBell color={"white"} size={18} />
				{totalUnread > 0 && (
					<span className="unseen-notifications-badge">
						<span>
							{totalUnread}
						</span>
					</span>
				)}
			</button>
			<div ref={dropdownRef} className="notifications-dropdown" data-open={showDropdown}>
				<header>
					<div className="notifications-title">
						<h2>
							<FaRegBell size={16} />
							Notificações
							{isLoading && <Loader width={15} height={15} />}
						</h2>
						<div className="unseen-info">
							{totalUnread > 0 && (
								<span>{totalUnread}</span>
							)}
							<button type="button" disabled={totalUnread === 0} onClick={onReadAllClick} className="read-all-button">
								<LuCheckCheck size={16} />
							</button>
						</div>
					</div>
					<AnimatedTabbar value={tab} className={`px-3.5!`} onChange={value => {
						setTab(value);
						setCategorySearchBy(value === 1 ? '' : 'alarm');
					}}>
						<AnimatedTabbarItem name={1}>
							Todas
						</AnimatedTabbarItem>
						<AnimatedTabbarItem name={2}>
							Alertas
						</AnimatedTabbarItem>
					</AnimatedTabbar>
				</header>
				<div className="notifications-list">
					{notifications.length > 0 ? (
						<>
							{notifications.map((notification, idx) => <NotificationCard key={idx} notification={notification} />)}
						</>
					) : (
						<div className="empty-notifications">
							<LuInbox size={52} />
							<h4>Tudo quieto por aqui</h4>
						</div>
					)}
				</div>
			</div>
		</>
	);
}